import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAllMajorCategory } from '../../../redux/admin/category/category_services_syn';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { InfinitySpin } from 'react-loader-spinner';
import CKEditorComponent from '../../../component/ckEdtorComponent';
import {
  BloggerUploadImage,
  EditBlogger,
  PostBlogger,
} from '../../../redux/admin/bloggers/bloggersServicesSync';
import { updateCoverPics } from '../../../redux/admin/bloggers/bloggersSlices';
import { blogFormikForm, blogSchema } from '../../../yups/blog_yups';
import HTMLReactParser from 'html-react-parser';

const Edit_Blogs = () => {
  const dispatch = useDispatch();

  const [images, setImages] = useState({});

  const [editorContent, setEditorContent] = useState('');

  const [editorWordCount, setEditorWordCount] = useState(0);

  const { isPicLoading, contentDetails, isBlogLoading, singleBlogDetails } =
    useSelector((state) => state.blogger);

  useEffect(() => {
    dispatch(GetAllMajorCategory());

    return () => {};
  }, []);

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (isBlogLoading) return;

    if (
      typeof contentDetails === 'object' &&
      Object.keys(contentDetails).length === 0
    ) {
      toast('Images and thumbnail missing, please click to add them');

      return;
    }

    const payload = {
      ...value,
      cover_pic: contentDetails?.secure_url,
      cover_pic_id: contentDetails?.public_id,
      wordCount: editorWordCount,
      article: editorContent,
    };

    dispatch(EditBlogger({ ...singleBlogDetails, ...payload }));

    resetForm();

    dispatch(updateCoverPics({}));
    setEditorContent('');
    setEditorWordCount(0);
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: blogFormikForm,
    validationSchema: blogSchema,
    onSubmit: handleSubmited,
  });

  const handleProductImage = async (e) => {
    if (isPicLoading) return;

    const image = e.target.files[0];

    if (image) {
      const formData = new FormData();

      formData.append(`file`, image);

      await dispatch(BloggerUploadImage(formData));

      setImages(image);
    }
  };

  useEffect(() => {
    setFieldValue('title', singleBlogDetails?.title);
    setFieldValue('hash_tag', singleBlogDetails?.hash_tag);

    setEditorContent(singleBlogDetails?.article || '');

    setEditorWordCount(singleBlogDetails?.wordCount);

    dispatch(
      updateCoverPics({
        secure_url: singleBlogDetails?.cover_pic,
        public_id: singleBlogDetails?.cover_pic_id,
      })
    );

    setImages({ name: singleBlogDetails?.cover_pic });
  }, [singleBlogDetails]);

  const handleChangeBlogHashTag = (e) => {
    const value = e?.target?.value;

    // Determine if the user pressed the backspace or delete key
    const isBackspaceOrDelete =
      e.nativeEvent.inputType === 'deleteContentBackward' ||
      e.nativeEvent.inputType === 'deleteContentForward';

    if (!isBackspaceOrDelete) {
      const modifiedText = value
        .split(' ')
        .map((word) => {
          return word.startsWith('#') ? word.replace(/#+/, '#') : '#' + word;
        })
        .join(' ');

      setFieldValue('hash_tag', modifiedText);
    } else {
      setFieldValue('hash_tag', value);
    }
  };

  return (
    <>
      <div class="row">
        <div class="col-xl-3 col-lg-4">
          <div class="card">
            <div class="card-body">
              {contentDetails?.secure_url && (
                <img
                  src={contentDetails?.secure_url}
                  alt=""
                  class="img-fluid rounded bg-light"
                />
              )}
              <div class="mt-3">
                <h4>{`${images.name}`}</h4>

                <h5 class="text-dark fw-medium mt-3">Images:</h5>
                <h4 class="fw-semibold text-dark mt-2 d-flex align-items-center gap-2">
                  {Array.from(images).length}
                </h4>
              </div>
            </div>
            <div class="card-footer bg-light-subtle">
              <div class="row g-2">
                {/* <div class="col-lg-6">
                  <a href="#!" class="btn btn-outline-secondary w-100">
                    Create Product
                  </a>
                </div> */}
                <div class="col-lg-6">
                  <a href="#!" class="btn btn-primary w-100">
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-8 ">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Add Product Photo</h4>
            </div>
            <div class="card-body">
              <form
                action="https://techzaa.in/"
                method="post"
                class="dropzone"
                id="myAwesomeDropzone"
                data-plugin="dropzone"
                data-previews-container="#file-previews"
                data-upload-preview-template="#uploadPreviewTemplate"
                style={{ position: 'relative' }}
              >
                <div class="fallback">
                  <input
                    name="file"
                    type="file"
                    multiple
                    onChange={handleProductImage}
                    style={{
                      border: '1px solid red',
                      position: 'absolute',
                      width: '98%',
                      height: '90%',
                      opacity: 0,
                    }}
                  />
                </div>
                <div class="dz-message needsclick">
                  <i class="bx bx-cloud-upload fs-48 text-primary"></i>
                  <h3 class="mt-4">
                    Drop your images here, or{' '}
                    <span class="text-primary">click to browse</span>
                  </h3>
                  <span class="text-muted fs-13">
                    {images ? (
                      <>{`${images.name}  `}</>
                    ) : (
                      <>
                        1600 x 1200 (4:3) recommended. PNG, JPG and GIF files
                        are allowed
                      </>
                    )}
                  </span>
                </div>
              </form>
            </div>

            {isPicLoading && (
              <div class="form-group col-sm-9">
                <InfinitySpin width="100" color="#FE6B30" />
              </div>
            )}
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Product Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="product-name" class="form-label">
                        Blog Title
                      </label>
                      <input
                        type="text"
                        id="product-name"
                        class="form-control"
                        placeholder="Blog Title"
                        value={values.title || ''}
                        onChange={handleChange}
                        name="title"
                        style={{
                          border: errors.title && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="product-id" class="form-label">
                        Hash Tag
                      </label>
                      <input
                        type="text"
                        id="product-id"
                        class="form-control"
                        placeholder="#******"
                        value={values.hash_tag || ''}
                        onChange={handleChangeBlogHashTag}
                        name="hash_tag"
                        style={{
                          border: errors.hash_tag && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-3">
                    <label for="description" class="form-label">
                      Article
                    </label>

                    <CKEditorComponent
                      setEditorContent={setEditorContent}
                      setEditorWordCount={setEditorWordCount}
                      data={editorContent}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="p-3 bg-light mb-3 rounded">
            <div class="row justify-content-end g-2">
              {/* <div class="col-lg-2">
                <a href="#!" class="btn btn-outline-secondary w-100">
                  Create Product
                </a>
              </div> */}
              <div class="col-lg-2">
                <a class="btn btn-primary w-100" onClick={handleSubmit}>
                  {isBlogLoading ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="100" color="#FFFFFF" />
                    </div>
                  ) : (
                    <>Edit Blog</>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit_Blogs;
